<template>
    <div class="footer-main">
        <div class="top commonCenter divFlex">
            <ul>
                <li class="title">USEFUL LINKS</li>
                <li class="desc" @click="router.push('/')">Home</li>
                <li class="desc" @click="router.push('/about')">About</li>
                <li class="desc" @click="router.push('/contact')">Contact Us</li>
                <li class="desc" @click="router.push('/')">Site Map</li>
            </ul>
            <ul>
                <li class="title">POLICIES</li>
                <li class="desc" @click="router.push('/privacy')">Privacy Policy</li>
                <li class="desc" @click="router.push('/terms')">Terms & Conditions</li>
                <li class="desc" @click="router.push('/refund')">Refund & Cancellation</li>
                <li class="desc" @click="router.push('/shipping')">Shipping policy</li>
            </ul>
            <ul>
                <li class="title">MY ACCOUNT</li>
                <li class="desc" @click="router.push('/login')">Log In</li>
                <li class="desc" @click="profileJump">Profile</li>
                <li class="desc" @click="shoppingCartClick">Cart</li>
            </ul>
            <div class="lineBreak">
                <div class="title">CONTACT INFO</div>
                <p><strong>Address:</strong> {{ footerData.info.Mall_Address }}</p>
                <p><strong>Email Us:</strong> {{ footerData.info.Mall_Email }}</p>
                <p><strong>Call Us:</strong> {{ footerData.info.Mall_Mobile }}</p>
                <p style="margin-top: 20px;">
                    <strong>Social Links... </strong>
                    <i>
                        <svg t="1740711972800" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="1653" id="mx_n_1740711972801" width="13"
                            height="13">
                            <path
                                d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z"
                                p-id="1654" fill="rgb(211,211,211)"></path>
                        </svg>
                    </i>
                    <i>
                        <svg t="1740712408081" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="3665" width="13" height="13">
                            <path
                                d="M1000.6528 316.6208c-2.4576-50.3808-10.6496-84.7872-22.9376-115.0976-12.6976-31.1296-29.4912-57.7536-56.5248-83.968a241.50016 241.50016 0 0 0-87.2448-54.4768c-31.1296-11.8784-67.1744-19.6608-119.1936-22.1184C662.3232 38.5024 645.5296 38.0928 512 38.0928 378.4704 38.0928 361.6768 38.5024 309.248 40.96c-52.0192 2.4576-88.064 10.6496-119.1936 22.528-32.3584 12.288-59.8016 28.2624-87.2448 54.4768-27.0336 26.2144-43.8272 52.8384-56.5248 83.968-12.288 30.3104-20.48 64.7168-22.9376 115.0976C20.8896 367.4112 20.48 383.3856 20.48 512c0 128.6144 0.4096 144.5888 2.8672 195.3792 2.4576 50.3808 10.6496 84.7872 22.9376 115.0976 12.6976 31.1296 29.4912 57.7536 56.5248 83.968 27.4432 26.2144 54.8864 42.5984 87.2448 54.4768 31.1296 11.8784 67.1744 19.6608 119.1936 22.1184 52.4288 2.4576 69.2224 2.8672 202.752 2.8672 133.5296 0 150.3232-0.4096 202.752-2.8672 52.4288-2.4576 88.064-10.24 119.1936-22.1184 32.3584-12.288 59.8016-28.2624 87.2448-54.4768 27.4432-26.2144 44.2368-52.8384 56.5248-83.968 12.288-30.3104 20.48-64.7168 22.9376-115.0976 2.4576-50.3808 2.8672-66.7648 2.8672-195.3792 0-128.6144-0.4096-144.5888-2.8672-195.3792z m-88.4736 386.6624c-2.048 46.2848-10.24 71.2704-16.7936 88.064-9.0112 22.1184-19.6608 37.6832-36.864 54.4768-17.2032 16.384-33.5872 27.0336-56.5248 35.6352-17.2032 6.5536-43.4176 14.336-91.3408 16.384-52.0192 2.4576-67.1744 2.8672-198.656 2.8672-131.072 0-146.6368-0.4096-198.656-2.8672-47.9232-2.048-74.1376-9.8304-91.3408-16.384-22.9376-8.6016-39.3216-18.8416-56.5248-35.6352-17.2032-16.384-27.8528-32.3584-36.864-54.4768-6.5536-16.7936-14.7456-41.7792-16.7936-88.064-2.4576-49.9712-2.8672-64.7168-2.8672-191.2832s0.4096-141.312 2.8672-191.2832c2.4576-46.2848 10.24-71.2704 17.2032-88.064 9.0112-22.1184 19.6608-37.6832 36.864-54.4768 17.2032-16.384 33.5872-26.624 56.5248-35.2256 17.2032-6.5536 43.4176-14.336 91.3408-16.384 51.6096-2.4576 67.1744-2.8672 198.2464-2.8672s146.6368 0.4096 198.656 2.8672c47.9232 2.048 73.728 9.8304 91.3408 16.384 22.9376 8.6016 39.3216 18.8416 56.5248 35.2256 17.2032 16.384 27.8528 32.3584 36.864 54.4768 6.5536 16.7936 14.7456 41.7792 16.7936 88.064 2.4576 49.9712 2.8672 64.7168 2.8672 191.2832s-0.4096 141.312-2.8672 191.2832zM512 268.6976c-139.264 0-252.3136 108.9536-252.3136 243.3024 0 134.3488 113.0496 243.3024 252.3136 243.3024 139.264 0 252.3136-108.9536 252.3136-243.3024 0-134.3488-113.0496-243.3024-252.3136-243.3024z m0 400.9984c-90.5216 0-163.84-70.8608-163.84-157.696 0-87.2448 73.3184-157.696 163.84-157.696s163.84 70.8608 163.84 157.696c0 87.2448-73.3184 157.696-163.84 157.696z m262.5536-467.3536c-32.768 0-58.9824 25.3952-58.9824 56.9344 0 31.5392 26.2144 56.9344 58.9824 56.9344 32.768 0 58.9824-25.3952 58.9824-56.9344 0-31.5392-26.624-56.9344-58.9824-56.9344z"
                                fill="rgb(211,211,211)" p-id="3666"></path>
                        </svg>
                    </i>
                    <i>
                        <svg t="1740712107302" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="2691" width="13" height="13">
                            <path
                                d="M512.5 182c71.553 0 147.316 6.92 224.935 19.226a1903.434 1903.434 0 0 1 116.168 22.158l5.105 1.146c1.696 0.384 3.388 0.769 5.074 1.155l5.044 1.162 5.013 1.17c9.16 2.15 18.161 4.337 26.987 6.551C942.41 245 971 282.568 971 325.556v373.888c0 42.987-28.59 80.557-70.175 90.988l-2.411 0.603-4.849 1.202-4.882 1.196a1844.11 1844.11 0 0 1-9.864 2.374l-4.98 1.176-5.013 1.17-5.044 1.162-2.534 0.578-5.09 1.151a1903.512 1903.512 0 0 1-118.723 22.73C659.816 836.08 584.053 843 512.5 843s-147.316-6.92-224.935-19.226a1903.545 1903.545 0 0 1-118.723-22.73l-5.09-1.15-2.534-0.579-5.044-1.162-5.013-1.17c-1.665-0.39-3.326-0.783-4.98-1.176l-4.95-1.184-4.915-1.19-4.883-1.196-4.848-1.202-2.412-0.603C82.59 780 54 742.432 54 699.444V325.556c0-42.987 28.59-80.557 70.174-90.988 3.21-0.805 6.443-1.607 9.698-2.404l4.899-1.193c8.193-1.983 16.523-3.94 24.981-5.865l5.09-1.15a1903.555 1903.555 0 0 1 118.723-22.73C365.185 188.92 440.947 182 512.5 182z m-95.975 222.202v216.596c0 43.14 48.56 68.418 83.902 43.687l154.74-108.302c30.33-21.227 30.33-66.139 0-87.366l-154.74-108.302c-35.342-24.731-83.902 0.547-83.902 43.687z"
                                p-id="2692" fill="rgb(211,211,211)"></path>
                        </svg>
                    </i>
                </p>
            </div>
        </div>
        <div class="bottom commonCenter">
            Copyright © 2026 {{ footerData.info.Mall_Name }} | All
            Rights Reserved
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router'
const router = useRouter();
import { checkoutLogin } from '@/utils/utils'
import API from '@/utils/request'
import { useStore } from 'vuex'
const store = useStore()

const footerData = reactive({
    info: {}
})

// 获取官网数据
const commonContentGet = () => {
    API.getRequest('params/values', {
        codes: 'Mall_Address,Mall_Email,Mall_Mobile,Mall_Name,pay_channel'
    }, (res) => {
        footerData.info = res.data;
        document.title = res.data.Mall_Name ? res.data.Mall_Name : "Mall";
        store.commit('setCommonContent', res.data);
    })
}
commonContentGet();


// 跳转
const shoppingCartClick = () => {
    checkoutLogin(() => {
        router.push('/cart');
    })
}
const profileJump = () => {
    checkoutLogin(() => {
        router.push('/profile')
    })
}
</script>

<style scoped lang="scss">
.footer-main {
    color: $color2;
    background-color: $bgColor;

    .top {
        padding: 40px 0;
        align-items: flex-start;

        .title {
            padding-bottom: 10px;
            color: $color2;
        }

        >div {
            width: 320px;
        }

        ul {
            .desc {
                padding: 5px 0px 10px;
                color: $color3;
                cursor: pointer;
                transition: all .2s linear;

                &:hover {
                    color: $color2;
                    transform: translate(4px, -4px);
                }
            }
        }

        p {
            color: $color3;
            line-height: 1.7;
        }

        i {
            display: inline-block;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            line-height: 30px;
            border: 1px solid $color3;
            text-align: center;
            margin-left: 10px;
        }
    }

    .bottom {
        text-align: center;
        font-size: 14px;
        padding: 10px 0;
        color: $color3;
    }
}

@media screen and (max-width: 930px) {
    .footer-main {
        padding: 15px;

        .top {
            flex-wrap: wrap;
            padding: 20px 0;

            .title {
                margin-top: 20px;
            }

            ul {
                width: 50%;
            }

            >div {
                width: 50%;
            }
        }
    }
}
</style>